export default __webpack_public_path__ + "static/media/Neumannmic.ec52db2c.JPG";